import { formatNumber, FORMAT_PRESETS } from '@/utils/format.util';

/** Compact user headcount (e.g. 100000 → 100K). */
export function formatUserCount(count: number | null | undefined): string {
  return formatNumber(count, FORMAT_PRESETS.axis);
}

export function userCountLabel(count: number): string {
  return Math.abs(count) === 1 ? 'user' : 'users';
}

export function formatUserCountPhrase(count: number): string {
  return `${formatUserCount(count)} ${userCountLabel(count)}`;
}
